import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { CompactView, ListPanel, ZeroState, NewMessageButton } from 'ecs-react-components/dist/index.es';
import { messages } from './SecureMessages.i18n';
import SecureMessagesFilter from './SecureMessagesFilter';
import ThreadMessages from './ThreadMessages';
import Header from '../../components/Header/Header';
import * as MID from '../../redux/modules/secure-message/secure-message-middleware';
import {
  careProviderSelected,
  showSecureMessageReplyItem, secureMessageListViewCompact,
  secureMessageThreadSelected, secureMessageArchivedThreadSelected, secureMessageThreadClear,
} from '../../redux/modules/secure-message/actions/creators';
import SecureMessageForm from '../../containers/SecureMessage/SecureMessageForm';
import * as MsgBarActions from '../../redux/modules/system-shared/message-bar-action-creator';
import LoadingIndicatorContainer from '../LoadingIndicatorContainer';

class SecureMessagesCompact extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
    };
  }

  onNewMessageButtonClick = () => {
    this.props.dispatch(careProviderSelected(null));
    this.setState({ showModal: true });
    this.props.dispatch(MsgBarActions.dismissMessage());
  }

  closeModal = () => {
    this.setState({ showModal: !this.state.showModal });
  }

  handleBackButtonClick = () => {
    const { dispatch, filter } = this.props;
    dispatch(secureMessageListViewCompact(true));
    dispatch(secureMessageThreadClear());
    if (filter === 'Current') {
      dispatch(secureMessageThreadSelected(null));
    } else {
      dispatch(secureMessageArchivedThreadSelected(null));
    }
  }

  handleListItemClick = (index) => {
    const { language, timeZone, timeZoneOffset, filteredThreads, filter, dispatch, patientId } = this.props;

    dispatch(secureMessageListViewCompact(false));
    if (filter === 'Current') {
      dispatch(secureMessageThreadSelected(filteredThreads[index].itemId));
    } else {
      dispatch(secureMessageArchivedThreadSelected(filteredThreads[index].itemId));
    }
    dispatch(MID.threadMessagesRequested(
      patientId,
      filteredThreads[index].itemId,
      language,
      timeZone,
      timeZoneOffset)).then(
      (responses) => {
        dispatch(MID.patchReviewedThreadMessages(
          patientId,
          filteredThreads[index].itemId,
          responses.data,
          language,
          timeZone,
          timeZoneOffset));
      }
    );

    dispatch(showSecureMessageReplyItem(false));
    dispatch(secureMessageThreadSelected(filteredThreads[index].itemId));
    dispatch(MsgBarActions.dismissMessage());
  }

  renderZeroState() {
    return (
      <ZeroState
        zeroStateMessage={ <FormattedMessage { ...messages.page.zeroStateMessage } /> }
        stateIconCss="fa-solid fa-envelope"
        onButtonClick={ this.onNewMessageButtonClick }
      />
    );
  }

  renderHeaderPane() {
    return (
      <div>
        <Header headerTitle={<FormattedMessage { ...messages.page.title } />}
          badgeNumber={this.props.unreadCount}
          headerClassName="mb-3"
        />
      </div>
    );
  }

  renderFilterPane() {
    const { filteredThreads } = this.props;
    return (
      <div className="row mb-2">
        <div className="form-group col">
          <SecureMessagesFilter />
          {
            !filteredThreads || filteredThreads.length === 0 ?
            <NewMessageButton
              onClick={ this.onNewMessageButtonClick }
              buttonName={ messages.link.newMessage }
              buttonClassName="float-end"
            /> : ''
          }
        </div>
        <SecureMessageForm
          showModal={ this.state.showModal }
          close={ this.closeModal }
          initiatedfromMessagesModule
          compact
        />
      </div>
    );
  }

  renderListPane() {
    const { filteredThreads, filter } = this.props;
    if (filteredThreads && filteredThreads.length > 0) {
      return (
        <LoadingIndicatorContainer loadingKey="SecureMessagesCompact" >
          <div className="row g-0">
            <ListPanel
              items={filteredThreads}
              title={messages.listPanel.title}
              handleListItemClick={this.handleListItemClick}
              onButtonClick={ this.onNewMessageButtonClick }
              selectedIndex={
                filter === 'Current' ?
                  this.props.selectedThreadIndex :
                  this.props.selectedArchivedThreadIndex
              }
              qaTag="ThreadsContainer"
              wrapperClassName="col-lg-4 custom-list-wrapper"
            />
          </div>
        </LoadingIndicatorContainer>
      );
    }

    return undefined;
  }

  renderDetailsPane() {
    if (this.props.filteredThreads && this.props.filteredThreads.length > 0) {
      return (
          <ThreadMessages
            messages={ this.props.messages }
          />
      );
    }
    return null;
  }

  render() {
    return (
      <CompactView
        zeroState={this.renderZeroState()}
        headerPane={this.renderHeaderPane()}
        filterPane={this.renderFilterPane()}
        listPane={this.renderListPane()}
        detailsPane={this.renderDetailsPane()}
        backButtonLabel={ messages.page.backButton }
        handleBackButtonClick={this.handleBackButtonClick}
        isListView={this.props.isListView}
      />);
  }
}

SecureMessagesCompact.propTypes = {
  dispatch: PropTypes.func,
  badgeNumber: PropTypes.number,
  threads: PropTypes.array,
  messages: PropTypes.array,
  timeZone: PropTypes.string,
  language: PropTypes.string,
  timeZoneOffset: PropTypes.string,
  isReplyItemVisible: PropTypes.bool,
  filteredThreads: PropTypes.array,
  selectedThreadIndex: PropTypes.string,
  selectedArchivedThreadIndex: PropTypes.string,
  filter: PropTypes.string,
  isListView: PropTypes.bool,
  unreadCount: PropTypes.number,
  patientId: PropTypes.string,
};

const mapStateToProps = (state) => ({
  badgeNumber: 0,
  threads: state.secureMessage.threads,
  messages: state.secureMessage.messages,
  timeZone: state.facility.timeZoneAbbreviation,
  timeZoneOffset: state.facility.timeZoneOffset,
  language: state.language.languageCode,
  patientId: state.profile.patient.patientId,
  isReplyItemVisible: state.secureMessage.isReplyItemVisible,
  selectedThreadIndex: state.secureMessage.selectedThreadIndex,
  selectedArchivedThreadIndex: state.secureMessage.selectedArchivedThreadIndex,
  filter: state.secureMessage.filter,
  isListView: state.secureMessage.isListView,
  unreadCount: state.secureMessage.unreadCount,
});

export default connect(mapStateToProps)(SecureMessagesCompact);